<div class="container mx-auto">
  <h4 mat-dialog-title>{{eventtitle}}</h4>
    <div mat-dialog-content>
      <form #f="ngForm" [formGroup]="range">   
       
          <div class="row mt-5 mb-4">
            <mat-form-field>
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input [min]="minDate" [rangePicker]="picker">
                <input matStartDate matInput  (dateChange)="onStartDateChange($event)" formControlName="datestartvalue" placeholder="Start date" />
                <input matEndDate matInput placeholder="End date"  (dateChange)="onEndDateChange($event)" formControlName="dateendvalue" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
          <div class="row mt-5 mb-4 ms-3 me-3">
            <mat-form-field>
              <mat-label>Event Start</mat-label>
              <input matInput
                [matTimepicker]="timepicker"
                formControlName="timevalue">
                <mat-timepicker #timepicker/>
                <mat-timepicker-toggle [for]="timepicker" matSuffix/>
            </mat-form-field>
          </div>
          <div mat-dialog-actions class="row">
            <div class="col-6"><button mat-button class="btn btn-secondary" (click)="onCancel()">Cancel</button></div>
            <div class="col-6"><button mat-button class="btn btn-primary" (click)="onConfirm()">Confirm</button></div>
          </div>
       
    </form>
  </div>
</div>